var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.md))}})}
var staticRenderFns = []

export { render, staticRenderFns }